import React from 'react'
import {useOptionValues, useFormFieldAttributes, convertFieldNameToClassName} from "../../utils"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import es from 'react-phone-input-2/lang/es.json'
import de from 'react-phone-input-2/lang/de.json'
import ru from 'react-phone-input-2/lang/ru.json'
import jp from 'react-phone-input-2/lang/jp.json'
import fr from 'react-phone-input-2/lang/fr.json'
import cn from 'react-phone-input-2/lang/cn.json'
import pt from 'react-phone-input-2/lang/pt.json'
import it from 'react-phone-input-2/lang/it.json'
import ir from 'react-phone-input-2/lang/ir.json'
import ar from 'react-phone-input-2/lang/ar.json'
import tr from 'react-phone-input-2/lang/tr.json'
import id from 'react-phone-input-2/lang/id.json'
import hu from 'react-phone-input-2/lang/hu.json'
import pl from 'react-phone-input-2/lang/pl.json'
import ko from 'react-phone-input-2/lang/ko.json'
import {useSelector} from "react-redux";
import classNames from "classnames";
import RenderedHtmlContent from "../../../../../shared/virtual_congress/components/rendered_html_content";
import ConditionalDivWrapper from "./raw_fields/conditional_div_wrapper";
import CustomError from "./custom_error";
import {useFormContext, Controller} from "react-hook-form";
import {TextField} from "@material-ui/core";

const Phone = ({tagOwner, formMode, field}) => {
  const {control} = useFormContext();
  const {
    fieldName,
    title,
    fieldMode,
    placeholder,
    hint,
    errorMessage,
    prefill
  } = useFormFieldAttributes(formMode, field);

  const formFieldStyle = useSelector(state => state.form_field_style)
  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"
  const rawOptions = useSelector(state => state[formMode].field_values[field])

  const isHorizontal = formFieldStyle === "boostrap_horizontal"

  const options = JSON.parse(rawOptions || "{}")

  let language = de
  const languages = {
    "de": de,
    "es": es,
    "ru": ru,
    "jp": jp,
    "fr": fr,
    "cn": cn,
    "pt": pt,
    "it": it,
    "ir": ir,
    "ar": ar,
    "tr": tr,
    "id": id,
    "hu": hu,
    "pl": pl,
    "ko": ko,
  }

  if (languages[options.language]) {
    language = languages[options.language]
  }

  let style = ""
  if (formFieldStyle === "material_ui_filled") {
    style = `.phone-input-container {
        background-color: rgba(0, 0, 0, 0.09) !important;
        border-top-left-radius: 4px !important;
        border-top-right-radius: 4px !important;
        border-bottom: solid 1px rgba(0, 0, 0, 0.87);
      }
    
      .phone-input-container label {
        font-size: 14px !important;
        background: transparent !important;
        border: none !important;
        margin-bottom: 0 !important;
        padding-left: 12px;
      }
    
      .react-tel-input .flag-dropdown,
      .react-tel-input .form-control  {
        background-color: transparent !important;
        border: none !important;
      }`
  }

  return <>
    <style>{style}</style>
    <div className={classNames(`form-group phone-input-container phone-field-${convertFieldNameToClassName(name)}-container`, {"row": isHorizontal})}>
      <label htmlFor={fieldName}
             className={classNames(`r-label`, {[`col-md-${labelWidth} col-form-label-sm`]: isHorizontal})}>
        <RenderedHtmlContent html={title}/>
      </label>
      <ConditionalDivWrapper wrapWithDiv={isHorizontal} className={`col-md-${inputWidth}`}>
        <Controller
          name={fieldName}
          control={control}
          defaultValue={prefill ? tagOwner?.[field] || "" : ""}
          render={({field: { onChange, onBlur, value, name, ref }}) =>
            <PhoneInput
              inputRef={ref}
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              country={options.defaultCountry || 'at'}
              preferredCountries={options.perferedCountries || ["at", "de", "ch"]}
              enableSearch={options.searchEnabled || false}
              localization={language}
              placeholder={placeholder}
              inputProps={{
                id: fieldName,
                name,
              }}
            />}
        />

        {hint && <small className="form-text text-muted">
          <RenderedHtmlContent html={hint}/>
        </small>}
        <CustomError error={errorMessage} className={"d-block"}/>
      </ConditionalDivWrapper>
    </div>
  </>
}

export default Phone;
